import { ICONS_MAP } from './iconsMap.js';
export const findIconByHref = (href) => ICONS_MAP.find(({ origins }) => origins?.some((_) => href?.includes(_))) || {};
//# sourceMappingURL=findIconByHref.js.map